export const VIDEO_PLAYING_SIGNAL = 'playing';

export const VIDEO_ENDED_SIGNAL = 'ended';

export const VIDEO_CAN_PLAY_SIGNAL = 'canplay';
